import { useCallback } from 'react';
import { useToast as useToastParallax } from '@adc/parallax-component-library';
import { store } from 'Utilities/store';
const useToast = () => {
    const { showToast: showToastParallax } = useToastParallax();
    const showToast = useCallback((props) => {
        const toastTimerEnv = store.getState().env.toastTimer;
        showToastParallax({
            ...props,
            duration: toastTimerEnv ?? props.duration ?? 3000,
        });
    }, [showToastParallax]);
    return { showToast };
};
export default useToast;
